export class UtilsURLS {
  public static urls(value: string): string {
    if ((process.env.VUE_APP_PRODUCTION as string) === "false") {
      return value;
    }
    return (process.env.VUE_APP_PUBLIC_PATH as string) + value;
  }
}
